import React from 'react';
import { useLanguage } from '@contexts/LanguageContext';
import { Collection, Tabs } from '@components/common';
import './LocationTransactions.scss';

export const LocationTransactions = ({
    locationId,
    className = ''
}) => {
    const { t } = useLanguage();

    // Create tabs configuration
    const tabs = [
        {
            id: 'resources',
            label: t('locationView.transactions.resources'),
            content: (
                <div className="tab-content resources-tab">
                    <Collection
                        modelName="resources"
                        title={t('locationView.transactions.resourcesInLocation')}
                        displayType="grid"
                        enablePagination={true}
                        enableSearch={true}
                        queryParams={{ location_id: locationId }}
                        className="transaction-collection location-resources-collection"
                    />
                </div>
            )
        },
        {
            id: 'borrowings',
            label: t('locationView.transactions.borrowings'),
            content: (
                <div className="tab-content borrowings-tab">
                    <Collection
                        modelName="locations"
                        endpoint="getBorrowings"
                        title={t('locationView.transactions.borrowingsFromLocation')}
                        displayType="list"
                        enablePagination={true}
                        enableSearch={false}
                        modelId={locationId}
                        className="transaction-collection location-borrowings-collection"
                    />
                </div>
            )
        },
        {
            id: 'consumptions',
            label: t('locationView.transactions.consumptions'),
            content: (
                <div className="tab-content consumptions-tab">
                    <Collection
                        modelName="locations"
                        endpoint="getConsumptions"
                        title={t('locationView.transactions.consumptionsFromLocation')}
                        displayType="list"
                        enablePagination={true}
                        enableSearch={false}
                        modelId={locationId}
                        className="transaction-collection location-consumptions-collection"
                    />
                </div>
            )
        },
        {
            id: 'refills',
            label: t('locationView.transactions.refills'),
            content: (
                <div className="tab-content refills-tab">
                    <Collection
                        modelName="locations"
                        endpoint="getRefills"
                        title={t('locationView.transactions.refillsToLocation')}
                        displayType="list"
                        enablePagination={true}
                        enableSearch={false}
                        modelId={locationId}
                        className="transaction-collection location-refills-collection"
                    />
                </div>
            )
        }
    ];

    return (
        <div className={`location-transactions ${className}`}>
            <Tabs
                tabs={tabs}
                variant="underline"
                size="medium"
                persistInUrl={true}
                urlParamName="locationTab"
                className="location-transactions-tabs"
            />
        </div>
    );
};

export default LocationTransactions;
